<template>
    <div class="v-table v-presentationtable" :class="{'v-table--loading':loading}">
		<div class="row margin-bottom-medium">
            <div class="col col-xs-12 col-sm-10">
                <div class="inline-block">
                    <h1 class="st-headline st-headline--1">{{ $t('Presentations') }}</h1>
                </div>
            </div>
            <div class="col col-xs-12 col-sm-2 text-sm-right">
            	<a v-if="canCreate" :href="canCreate" class="st-btn st-btn--sm"><i class="fa fa--plus"></i> {{ $t("Create") }}</a>
            </div>
        </div>

		<!--
		<div class="row">
			<div class="col-xs-12 col-sm-6 col-md-8">

			</div>
			<div class="col-xs-12 col-sm-6 col-md-4">
				<div v-if="partners" class="row margin-bottom-medium">
					<div class="col col-xs-12 text-right">
						<strong>Select Partner</strong>
						<selectize multiple v-model="involved.partners" @input="update()">
							<option v-for="u in partners" :value="u.id">{{ u.fancyname }}</option>
						</selectize>
					</div>
				</div>

				<div v-if="customers" class="row margin-bottom-medium">
					<div class="col col-xs-12 text-right">
						<strong>Select Customer</strong>
						<selectize multiple v-model="involved.customers" @input="update()">
							<option v-for="u in customers" :value="u.id">{{ u.fancyname }}</option>
						</selectize>
					</div>
				</div>
			</div>
		</div>
		-->


        <div class="row margin-bottom-medium">
            <div class="col-xs-12 col-sm-6">
                <div class="st-filters">
                    <div class="inline">
                        <div class="inline">
                            <button class="st-filters__link" :class="{'st-filters__link--active': !hasfitlers() }" @click="resetFilters">{{ $t('All') }}</button><span> | </span>
                        </div>
                        <div class="inline">
                            <button class="st-filters__link" :class="{ 'st-filters__link--active': filters.my }" @click="toggleMy()">{{ $t('My') }}</button><span> | </span>
                        </div>
                        <div class="inline">
                            <button class="st-filters__link" :class="{ 'st-filters__link--active': filters.progress_status == 'final' }"  @click="toggleProgressStatus('final')">{{ $t('Final') }}</button><span> | </span>
                        </div>
                        <div class="inline">
                            <button class="st-filters__link" :class="{ 'st-filters__link--active': filters.progress_status == 'draft' }"  @click="toggleProgressStatus('draft')">{{ $t('Draft') }}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-6 text-sm-right">
                <input :disabled="loading" class="st-input st-input--sm st-input--text st-input--search" :placeholder="$t('Search ...')" type="text" v-model="searchtext" @keyup="updateSearch">

                <div class="inline-block">
                    <v-paging :current_page="parseInt(filters.page)" :min_page="1" :max_page="pages" @pagechange="changePageByNumber" @prev="changePage" @next="changePage"></v-paging>
                </div>
            </div>
        </div>

        <table v-if="presentations" class="st-table st-table--full">
            <thead>
                <tr>
                    <th>{{ $t('Title') }}</th>
                    <th>{{ $t('Appointment') }}</th>
                    <th>{{ $t('Customers') }}</th>
                    <th>{{ $t(channel.roles.partner.plural) }}</th>
                    <th>{{ $t(channel.roles.kam.plural) }}</th>
                    <th>{{ $t('Created by') }}</th>
                    <th>{{ $t('Last edit') }}</th>
                </tr>
            </thead>
            <tbody>

                <tr v-for="(presentation, index) in presentations" :class="{ 'has-action' : presentation.urls && Object.keys(presentation.urls).length > 0, 'tr-is-editing' : isSomeoneEditing(presentation.id) }">
                    <td>
						<c-presentation @delete="presentations.splice(index, 1);" :data="presentation"></c-presentation>
                    </td>
                    <td>
                        {{ presentation.appointment }}
                    </td>
                    <td>
                        <div v-if="presentation.customer">
                            <c-user :simple="true" v-if="presentation.customer" :data="presentation.customer"></c-user>
                        </div>
                    </td>
                    <td>
                        <div v-if="presentation.partner">
                            <c-user :simple="true" v-if="presentation.partner" :data="presentation.partner"></c-user>
                        </div>
                    </td>
                    <td>
                        <div v-if="presentation.involved">
                            <div v-for="kam in presentation.involved">
                                <c-user :simple="true" v-if="kam && kam.mainrole && kam.mainrole.name == 'kam'" :data="kam"></c-user>
                            </div>
                        </div>
                    </td>
                    <td>
                    	<c-user :simple="true" v-if="presentation.createdUser" :data="presentation.createdUser" :canedit="(presentation.createdUser.urls && Object.keys(presentation.createdUser.urls).length > 0)"></c-user>
                    </td>
                    <td>
                        {{ moment(presentation.modified) }}
                    </td>
                </tr>
                <tr v-if="presentations.length <= 0">
					<td :colspan="Object.keys(channel.roles).length + 2">{{ $t('Nothing Found') }}</td>
            	</tr>
            </tbody>
        </table>
        <div class="row margin-top-medium">
            <div class="col-xs-12 col-sm-6"></div>
            <div class="col-xs-12 col-sm-6 text-sm-right">
                <v-paging :current_page="parseInt(filters.page)" :min_page="1" :max_page="pages" @pagechange="changePageByNumber" @prev="changePage" @next="changePage"></v-paging>
            </div>
        </div>
    </div>
</template>

<script>
import help_table from '@/helpers/table';
import help_general from '@/helpers/general';
import helper_user from '@/helpers/user';

import Selectize from 'vue2-selectize'
import CUser from '@/components/c-user';
import CPresentation from '@/components/c-presentation';

export default {
  	name: 'v-presentationtable',
	components: {
		Selectize,
		CPresentation,
		CUser
	},
	data: function () {
		const channel = this.$store.getters.channel,
			  role = channel.roles[this.rolename];

	    return {
	    	channel,
	    	role,

	    	involved: {
	    		partners: [],
	    		customers: [],
	    	},
	    	partners: false,
			customers: false,

	    	canCreate: false,

	    	loading: false,
	    	presentations: [],
	    	searchtext: '',
	    	pages: 0,
	    	filters: {
	    		q: '',
	    		page: 1,
	    		my: false,
	    		roles: [],
	    		involved: [],
	    	},
	    };
	},
	created: function () {
		this.filters = Object.assign({}, this.filters, this.$router.history.current.query);

		var self = this;
		Object.keys(this.filters).forEach(function(i){
			if(self.filters[i] === 'false') self.filters[i] = false;
			if(self.filters[i] === 'true') self.filters[i] = true;
			if(parseInt(self.filters[i]) > 0) self.filters[i] = parseInt(self.filters[i]);
		});

		this.update();
	},
	watch: {
		'$route': 'update'
	},
	methods: {
		...help_table,

		resetFilters: function(){
			this.filters.progress_status = undefined;
			this.filters.my = false;
			this.update();
		},

		update: function(){
			var self = this,
				url = this.$store.getters.channel.urls.presentations;
				//
			if(self.loading) return;
			self.loading = true;
			self.$store.commit('START_LOADING', 'presentations');

			self.filters.involved = [];
			Object.keys(self.involved).forEach( key => {
				let item = self.involved[key];
				item.forEach(id => {
					self.filters.involved.push(id);
				});

			});

			$.getJSON(
				url,
				self.filters,
				function(data){
					self.presentations = data.message;
					self.$store.commit('END_LOADING', 'presentations');

					if(data.notices){
						data.notices.forEach(notice => {
							self.$store.commit('ADD_NOTICE', notice);
						});
					}

					if(data.urls){
						if(data.urls.new) {
							self.canCreate = data.urls.new;
						}
					} else {
						self.canCreate = false;
					}



					if(data.total) {
						if(typeof self.filters.limit !== 'undefined' && data.limit !== self.filters.limit){
							self.filters.limit = data.limit;
						}

						var filters = self.filters;
						try	{
							// self.$router.push({ query: JSON.parse(JSON.stringify(filters)) });
						} catch (e){
							console.error(e);
						}


						let pages = Math.floor(data.total/(data.limit == 0 ? 10 : data.limit));
						if(pages <= 0) pages = 1;
						self.pages = pages;
					}
					self.loading = false;
				}
			);
		},


		isSomeoneEditing(id){
			var presentation_edit_status = this.$store.getters['socket/getFromLive']('presentation_edit_status');
			return typeof presentation_edit_status[id] !== 'undefined';
		},


		changePageByNumber: function(numb){
			console.log(numb);
			console.log(this.filters.page);
			this.filters.page = numb;
			console.log(this.filters.page);
			this.update();
		},

		changePage: function(add){
			this.filters.page = this.filters.page + add;
			this.update();
		},

		toggleProgressStatus: function(name){
			this.filters.progress_status = name;
			this.update();
		},

		copyLink(ev){
			ev.preventDefault();
			const href = ev.target.getAttribute('href');
			help_general.copyToClipboard(href);
			self.$emit('copyedLink', href);
		},
		iscurrentrole: helper_user.iscurrentrole,
		iscurrentsubrole: helper_user.iscurrentsubrole,
		issubrole: helper_user.issubrole,
		isleaderrole: helper_user.isleaderrole,
		getroleusers: helper_user.getroleusers,
		hasfitlers: helper_user.hasfitlers,
	}
}
</script>

<style scoped>
.tr-is-editing {
	opacity: 0.7;
}
</style>



// WEBPACK FOOTER //
// src/components/v-presentationtable.vue